import * as React from "react";
import styled from "styled-components";
import { darken, Stack } from "@mui/material";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import { useLocation } from "react-router-dom";
import AdadotLink from "src/components/link";
import Button from "@mui/material/Button";

const FooterWrapper = styled.footer`
    background-color: ${({ theme }) => darken(theme.palette.background.default, 0.18)};
    width: 100%;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    bottom: 0;
    z-index: 3;
    font-size: 12px;
    font-weight: 300;
    color: ${({ theme }) => theme.palette.text.secondary};
    text-align: right;
`;

const BootstrapButton = styled(Button)`
    color: ${({ theme }) => theme.palette.secondary.footer};
    box-shadow: none;
    text-transform: none;
    font-size: 10px;
    padding: 6px 12px;
    border: none;
    line-height: 1;
`;

const Footer: React.FC = () => {
    const location = useLocation();

    if (location.pathname === "/login-username") return null;

    return (
        <FooterWrapper>
            <Stack direction="row" spacing={2} justifyContent="flex-end" style={{ width: "95%" }}>
                <AdadotLink variant="plain" to="/changelog">
                    <BootstrapButton size="small" startIcon={<FormatListBulletedIcon />}>
                        Changelog
                    </BootstrapButton>
                </AdadotLink>
                {location.pathname !== "/roadblock" && (
                    <BootstrapButton
                        href="mailto: info@adadot.com"
                        size="small"
                        startIcon={<SupportAgentIcon />}
                    >
                        Support
                    </BootstrapButton>
                )}
            </Stack>
        </FooterWrapper>
    );
};

export default Footer;
